module.exports = {
  OneClick: {
    PluginName: "Tıklama",
  },
};
